<aside class="app-sidebar" [class.minified]="isMinified">
  <div class="sidebar-inner">
    <!-- Brand / top row -->
    <div class="sidebar-brand">
      <div class="brand-left" (click)="onToggleSidebar()">
        <!-- Full logo for normal sidebar -->
        <span class="brand-logo full-logo" aria-hidden="true" *ngIf="!isMinified">
          <svg xmlns="http://www.w3.org/2000/svg" width="106" height="22" viewBox="0 0 106 22" fill="none">
            <path
              d="M18.8502 5.33677C17.7146 2.15289 14.6865 -1.33514e-05 11.3101 -1.33514e-05H0C0.0151407 3.94193 1.48379 7.71709 4.11828 10.6432L4.2394 10.7797L4.11828 10.9161C1.48379 13.8423 0.0302814 17.6174 0 21.5594H11.3101C14.6865 21.5594 17.7146 19.4216 18.8502 16.2226L20.3189 12.0835C20.6217 11.2345 20.6217 10.2945 20.3189 9.43032L18.8502 5.33677ZM2.75561 5.53386C2.25597 4.36644 1.92287 3.13838 1.75632 1.87999L1.72604 1.63741H11.3101C12.6274 1.63741 13.8992 2.04676 14.9893 2.80483C15.8978 3.45676 16.6397 4.33612 17.0939 5.35192L17.2301 5.65515H16.0037C12.1731 5.65515 8.46367 7.03483 5.55665 9.53644L5.40524 9.6729L5.26897 9.52128C4.22426 8.32354 3.37638 6.98935 2.75561 5.53386ZM17.0939 16.2529C16.6245 17.2687 15.8978 18.1481 14.9893 18.8C13.9143 19.5581 12.6425 19.9674 11.3101 19.9674H1.72604L1.75632 19.7248C1.92287 18.4665 2.25597 17.2384 2.75561 16.071C3.37638 14.6155 4.20912 13.2813 5.26897 12.0987L5.40524 11.9471L5.55665 12.0835C8.46367 14.5852 12.158 15.9648 16.0037 15.9648H17.2301L17.0939 16.2529ZM18.5625 12.1745L17.8055 14.3274H16.0037C14.0657 14.3274 12.1731 13.9484 10.4017 13.1903C9.08444 12.6294 7.85804 11.8864 6.75276 10.9616L6.55593 10.7948L6.75276 10.6281C7.8429 9.70322 9.06929 8.96031 10.4017 8.39935C12.1731 7.65644 14.0506 7.26225 16.0037 7.26225H17.8055L18.5625 9.41516C18.8805 10.3097 18.8805 11.2952 18.5625 12.1745Z"
              fill="#FC5810" />
            <path
              d="M43.3936 6.79237C40.1989 6.79237 37.5947 9.40012 37.5947 12.5992C37.5947 15.7982 40.1989 18.4059 43.3936 18.4059C46.5883 18.4059 49.1925 15.7982 49.1925 12.5992C49.1925 9.40012 46.5883 6.79237 43.3936 6.79237ZM43.3936 16.3137C41.3496 16.3137 39.6841 14.6459 39.6841 12.5992C39.6841 10.5524 41.3496 8.88464 43.3936 8.88464C45.4376 8.88464 47.1031 10.5524 47.1031 12.5992C47.1031 14.6459 45.4376 16.3137 43.3936 16.3137Z"
              fill="white" />
            <path
              d="M60.1541 11.8865L57.7013 11.4165C57.3076 11.3407 56.1115 11.1436 56.1115 10.0823C56.1115 9.61232 56.3689 9.18781 56.8231 8.89974C57.2319 8.642 57.7618 8.50555 58.3372 8.50555C59.3365 8.50555 60.3358 8.89974 61.3199 9.67296L61.3502 9.70329L62.5312 8.2478L62.5009 8.21748C61.0777 7.232 59.7756 6.80748 58.2766 6.80748C56.1569 6.80748 54.007 8.02039 54.007 10.3401C54.007 11.7501 54.6731 12.8114 57.9435 13.4178L59.3213 13.6755C60.366 13.8726 60.9111 14.373 60.9111 15.131C60.9111 15.8891 59.9573 16.7078 58.5189 16.7078C57.3379 16.7078 55.9601 16.1014 55.0062 15.1462L54.976 15.1159L53.5527 16.5714L53.583 16.6017C55.0971 17.8449 56.6263 18.421 58.3978 18.421C59.8967 18.421 61.1382 17.9965 61.971 17.1778C62.6372 16.5259 63.0308 15.6465 63.0308 14.7672C63.0157 13.1601 62.1072 12.2504 60.1541 11.8865Z"
              fill="white" />
            <path
              d="M79.8822 15.7223C79.322 15.4039 78.8678 14.9036 78.5953 14.3123C78.0048 13.0539 78.0653 11.6894 78.777 10.5978C79.4583 9.52135 80.6241 8.88458 81.8959 8.88458C83.1223 8.88458 84.273 9.49103 84.9544 10.522L84.9847 10.5523L86.7107 9.3849L86.6804 9.35458C85.6054 7.76264 83.8188 6.80748 81.8959 6.80748C79.9882 6.80748 78.2016 7.74748 77.1266 9.33942C76.0213 10.9617 75.8245 12.9781 76.5815 14.8885C77.066 16.1165 77.9745 17.1172 79.1403 17.7085C80.0185 18.1481 80.9572 18.3756 81.9111 18.3756C83.8642 18.3756 85.6811 17.3901 86.741 15.7526L86.7713 15.7223L85.0301 14.5852L84.9998 14.6156C83.8794 16.2833 81.684 16.7685 79.8822 15.7223Z"
              fill="white" />
            <path
              d="M35.8078 3.1991H33.673L33.7487 3.27491C34.1878 3.72975 34.43 4.32104 34.43 4.95781V18.0875H36.5497V3.92684C36.5497 3.53265 36.2166 3.1991 35.8078 3.1991Z"
              fill="white" />
            <path
              d="M28.056 3.1991H25.9211L25.9968 3.27491C26.4359 3.72975 26.6782 4.32104 26.6782 4.95781V18.0875H28.7979V3.92684C28.7979 3.53265 28.4648 3.1991 28.056 3.1991Z"
              fill="white" />
            <path
              d="M31.9921 7.09541H29.8573L29.933 7.17122C30.3721 7.62606 30.6143 8.21735 30.6143 8.85413V18.0874H32.734V7.83832C32.734 7.42897 32.4009 7.09541 31.9921 7.09541Z"
              fill="white" />
            <path
              d="M89.058 3.1991C88.3161 3.1991 87.7104 3.80555 87.7104 4.54846C87.7104 5.29136 88.3161 5.89781 89.058 5.89781C89.7999 5.89781 90.4055 5.29136 90.4055 4.54846C90.4055 3.80555 89.7999 3.1991 89.058 3.1991Z"
              fill="white" />
            <path
              d="M89.3754 7.11081H87.2406L87.3163 7.18661C87.7554 7.64145 87.9976 8.23274 87.9976 8.86952V18.1028H90.1173V7.85371C90.1022 7.42919 89.7842 7.11081 89.3754 7.11081Z"
              fill="white" />
            <path
              d="M105.258 3.1991H103.123L103.199 3.27491C103.638 3.72975 103.88 4.32104 103.88 4.95781V18.0875H106V3.92684C105.985 3.53265 105.652 3.1991 105.258 3.1991Z"
              fill="white" />
            <path
              d="M100.428 7.11071V8.38425L100.353 8.27813C99.6713 7.35329 98.4146 6.80748 96.9914 6.80748C93.509 6.80748 91.1774 9.80942 91.1774 12.6143C91.1774 14.0697 91.7224 15.5101 92.6763 16.5865C93.4182 17.4204 94.7506 18.421 96.8854 18.421C98.2784 18.421 99.6108 17.8449 100.368 16.9201L100.443 16.8291V18.1026H102.563V7.11071H100.428ZM100.428 14.2668C99.8227 15.601 98.5812 16.4197 97.1731 16.4197C95.114 16.4197 93.4333 14.7065 93.4333 12.5991C93.4333 10.4917 95.114 8.77845 97.1731 8.77845C98.5812 8.77845 99.8227 9.59716 100.428 10.9314V10.9465V14.2668Z"
              fill="white" />
            <path
              d="M31.6746 3.1991C30.9327 3.1991 30.327 3.80555 30.327 4.54846C30.327 5.29136 30.9327 5.89781 31.6746 5.89781C32.4164 5.89781 33.0221 5.29136 33.0221 4.54846C33.0221 3.80555 32.4164 3.1991 31.6746 3.1991Z"
              fill="white" />
            <path
              d="M69.4199 6.79237C66.2252 6.79237 63.621 9.40012 63.621 12.5992C63.621 15.7982 66.2252 18.4059 69.4199 18.4059C72.6146 18.4059 75.2188 15.7982 75.2188 12.5992C75.2188 9.40012 72.6146 6.79237 69.4199 6.79237ZM69.4199 16.3137C67.3759 16.3137 65.7104 14.6459 65.7104 12.5992C65.7104 10.5524 67.3759 8.88464 69.4199 8.88464C71.4639 8.88464 73.1293 10.5524 73.1293 12.5992C73.1445 14.6459 71.479 16.3137 69.4199 16.3137Z"
              fill="white" />
          </svg>
        </span>

        <!-- Compact logo for minified sidebar -->
        <span class="brand-logo compact-logo" aria-hidden="true" *ngIf="isMinified">
          <img src="/images/stitch-logo.svg" alt="Stitch" />
        </span>
      </div>
      <svg *ngIf="!isMinified" (click)="onToggleSidebar()" xmlns="http://www.w3.org/2000/svg" height="20px"
        viewBox="0 -960 960 960" width="20px" fill="#FFFFFF">
        <path
          d="M211-144q-27.64 0-47.32-19.68T144-211v-538q0-27.64 19.68-47.32T211-816h538q27.64 0 47.32 19.68T816-749v538q0 27.64-19.68 47.32T749-144H211Zm125-72v-528H216v528h120Zm72 0h336v-528H408v528Zm-72 0H216h120Z" />
      </svg>
    </div>

    <!-- Company selector -->
    <div class="company-dropdown-container">
      <button class="company-select" type="button" (click)="toggleDropdown()">
        <span class="company-avatar">
          {{ currentBot ? getBotInitials(currentBot.name) : 'CN' }}
        </span>
        <span class="company-name" *ngIf="!isMinified">
          {{ currentBot ? currentBot.name : 'SELECT STORE' }}
        </span>
        <svg *ngIf="!isMinified" xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
          <path d="M8.17188 1L4.63634 4.53553L1.10081 1" stroke="white" stroke-linecap="round" />
        </svg>
      </button>

      <!-- Dropdown menu -->
      <div class="company-dropdown" *ngIf="showDropdown">
        <div class="dropdown-header">Select Store</div>
        <div class="dropdown-content">
          <div *ngIf="loadingBots" class="dropdown-loading">
            <div class="loading-spinner-small"></div>
            <span>Loading stores...</span>
          </div>
          <div *ngIf="!loadingBots && bots.length === 0" class="dropdown-empty">
            No stores found
          </div>
          <button *ngFor="let bot of bots" class="dropdown-item" type="button" (click)="selectBot(bot)"
            [class.active]="currentBot?.bot_id === bot.bot_id">
            <span class="dropdown-avatar">{{ getBotInitials(bot.name) }}</span>
            <span class="dropdown-name">{{ bot.name }}</span>
          </button>
        </div>
      </div>
    </div>



    <div *ngIf="showAddStorePopup" class="add-store-popup">
      <div class="popup-content">
        <input type="text" placeholder="Store name" [(ngModel)]="storeName" (keyup.enter)="createBot()"
          class="store-name-input" [disabled]="isCreating" />
        <button class="popup-confirm-btn" (click)="createBot()" [disabled]="isCreating">
          <span *ngIf="!isCreating">Create</span>
          <div *ngIf="isCreating" class="loading-spinner-small"></div>
        </button>
      </div>
    </div>

    <div class="sidebar-divider"></div>



    <div class="quick-links-section">
      <nav class="sidebar-nav">
        <a class="nav-item" *ngIf="hasBotContext()" [class.active]="isNavItemActive('chat')"
          (click)="navigateToChat(currentBot!.bot_id)">
          <svg width="34" height="33" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M17 0.5C26.1269 0.5 33.5 7.67741 33.5 16.5C33.5 25.3226 26.1269 32.5 17 32.5C7.87313 32.5 0.5 25.3226 0.5 16.5C0.5 7.67741 7.87313 0.5 17 0.5Z"
              fill="white" stroke="white" />
            <path d="M21.4 16.78H17.56V21.04H16.42V16.78H12.58V15.74H16.42V11.6H17.56V15.74H21.4V16.78Z"
              fill="#232323" />
          </svg>


          <span *ngIf="!isMinified">New Chat</span>
        </a>

        <a style="position: relative;left: 8px;" class="nav-item" *ngIf="hasBotContext()" [class.active]="isNavItemActive('chat-clients')"
          (click)="navigateToChatClients()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_145)">
              <path
                d="M10 0C4.48625 0 0 4.48625 0 10V19.375C0 19.72 0.28 20 0.625 20H10C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM10 18.75H1.25V10C1.25 5.175 5.175 1.25 10 1.25C14.825 1.25 18.75 5.175 18.75 10C18.75 14.825 14.825 18.75 10 18.75Z"
                fill="white" />
              <path
                d="M10.625 11.25H5.625C5.28 11.25 5 11.53 5 11.875C5 12.22 5.28 12.5 5.625 12.5H10.625C10.97 12.5 11.25 12.22 11.25 11.875C11.25 11.53 10.97 11.25 10.625 11.25Z"
                fill="white" />
              <path
                d="M14.375 7.5H5.625C5.28 7.5 5 7.78 5 8.125C5 8.47 5.28 8.75 5.625 8.75H14.375C14.72 8.75 15 8.47 15 8.125C15 7.78 14.72 7.5 14.375 7.5Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_1_145">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <span *ngIf="!isMinified">Past Conversations</span>
        </a>
        <div class="quick-links-header" *ngIf="!isMinified">QUICK LINKS</div>

        <a class="nav-item" *ngIf="hasBotContext()" [class.active]="isNavItemActive('settings')"
          (click)="navigateToSettings()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_1_3394)">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M11.1072 19.9883H8.89279C8.42414 19.9883 8.04921 19.6134 8.04921 19.1447V17.4458C7.36965 17.2584 6.72525 17.0006 6.11599 16.6374L4.9092 17.8442C4.58114 18.1722 4.04218 18.1722 3.71412 17.8442L2.14411 16.2859C1.81605 15.9578 1.81605 15.4189 2.14411 15.0908L3.35091 13.884C2.99941 13.2748 2.72994 12.6303 2.55419 11.9508H0.843585C0.386643 11.9508 0 11.5759 0 11.1072V8.8928C0 8.42414 0.386643 8.04921 0.843585 8.04921H2.55419C2.72994 7.36966 2.99941 6.72525 3.35091 6.11599L2.14411 4.9092C1.81605 4.58114 1.81605 4.04218 2.14411 3.71412L3.71412 2.15583C4.04218 1.81605 4.58114 1.81605 4.9092 2.15583L6.11599 3.35091C6.72525 2.99941 7.36965 2.72994 8.04921 2.55419V0.855302C8.04921 0.386643 8.42414 0 8.89279 0H11.1072C11.5759 0 11.9508 0.386643 11.9508 0.855302V2.55419C12.6303 2.72994 13.2748 2.99941 13.884 3.35091L15.0791 2.14411C15.4189 1.81605 15.9578 1.81605 16.2859 2.14411L17.8442 3.71412C18.1839 4.04218 18.1839 4.58114 17.8442 4.9092L16.6374 6.11599C17.0006 6.72525 17.2701 7.36966 17.4458 8.04921H19.1447C19.6134 8.04921 20 8.42414 20 8.8928V11.1072C20 11.5759 19.6134 11.9508 19.1447 11.9508H17.4458C17.2701 12.6303 17.0006 13.2748 16.6374 13.884L17.8442 15.0791C18.1839 15.4189 18.1839 15.9578 17.8442 16.2859L16.2859 17.8442C15.9578 18.1722 15.4189 18.1722 15.0791 17.8442L13.884 16.6374C13.2748 17.0006 12.6303 17.2584 11.9508 17.4341V19.1447C11.9508 19.6134 11.5759 19.9883 11.1072 19.9883ZM9.99414 15.0205C7.22906 15.0205 4.9795 12.7709 4.9795 9.99414C4.9795 7.22906 7.22906 4.9795 9.99414 4.9795C12.7709 4.9795 15.0205 7.22906 15.0205 9.99414C15.0205 12.7709 12.7709 15.0205 9.99414 15.0205Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_1_3394">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span *ngIf="!isMinified">Settings</span>
        </a>
        <a class="nav-item" [class.active]="isNavItemActive('stores')" (click)="navigateToStores()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M16.2531 0.6875H6.38185C5.1781 0.6875 4.19935 1.66687 4.19935 2.87062V3.32562H3.74435C2.54185 3.32562 1.56372 4.30375 1.56372 5.50562V17.1319C1.56372 18.3344 2.54185 19.3125 3.74435 19.3125H13.615C14.8168 19.3125 15.795 18.3344 15.795 17.1319V16.6744H16.2531C17.4568 16.6744 18.4356 15.695 18.4356 14.4912V2.87062C18.4362 1.66687 17.4568 0.6875 16.2531 0.6875ZM14.6706 17.1319C14.6706 17.7137 14.1975 18.1875 13.6156 18.1875H3.74435C3.16247 18.1875 2.68872 17.7137 2.68872 17.1319V5.50562C2.68872 4.92375 3.16247 4.45062 3.74435 4.45062H13.615C14.1968 4.45062 14.67 4.92375 14.67 5.50562L14.6706 17.1319ZM17.3112 14.4919C17.3112 15.0756 16.8368 15.55 16.2537 15.55H15.7956V5.50562C15.7956 4.30375 14.8175 3.32562 13.6156 3.32562H5.32435V2.87062C5.32435 2.28687 5.79872 1.8125 6.38185 1.8125H16.2531C16.8362 1.8125 17.3106 2.28687 17.3106 2.87062L17.3112 14.4919Z"
              fill="white" />
          </svg>
          <span *ngIf="!isMinified">Brands</span>
        </a>
      </nav>
    </div>

    <div class="sidebar-spacer"></div>

    <!-- User row -->
    <div class="sidebar-user" (click)="toggleUserPopup()">
      <div class="user-meta">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <g clip-path="url(#clip0_1_3407)">
            <circle cx="10.5" cy="8.5" r="4" stroke="white" />
            <path
              d="M10.5 12.5C12.4759 12.5 14.245 13.0876 15.5078 14.0137C16.771 14.94 17.5 16.1788 17.5 17.5C17.5 18.8212 16.771 20.06 15.5078 20.9863C14.245 21.9124 12.4759 22.5 10.5 22.5C8.52411 22.5 6.75504 21.9124 5.49219 20.9863C4.22904 20.06 3.5 18.8212 3.5 17.5C3.5 16.1788 4.22904 14.94 5.49219 14.0137C6.75504 13.0876 8.52411 12.5 10.5 12.5Z"
              stroke="white" />
          </g>
          <rect x="0.5" y="0.5" width="20" height="20" rx="10" stroke="white" />
          <defs>
            <clipPath id="clip0_1_3407">
              <rect width="21" height="21" rx="10.5" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span class="user-name" *ngIf="!isMinified">{{ userEmail }}</span>
      </div>

      <svg *ngIf="!isMinified" xmlns="http://www.w3.org/2000/svg" width="59" height="57" viewBox="0 0 59 57" fill="none"
        style="position: relative;top: 1px;right: -19px;">
        <path d="M26.8281 30L30.3637 26.4645L33.8992 30" stroke="white" stroke-linecap="round" />
      </svg>

      <!-- User Logout Popup -->
      <div class="user-popup" *ngIf="showUserPopup" (click)="$event.stopPropagation()">
        <div class="popup-content">
          <button class="logout-btn" type="button" (click)="logout()">
            <svg class="logout-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H6M10 6L14 10M14 10L10 14M14 10H6" \
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</aside>